module.exports = {
  url: '',
  template: require('raw!templates/layout.html'),
  controller: SiteController,
  abstract: true
}

function SiteController($scope, $rootScope, $state, contentful, $window) {

  $rootScope.goBack = function () {
    $window.history.back();
  }
  var b = document.documentElement;
  b.setAttribute('data-useragent', navigator.userAgent);
  b.setAttribute('data-platform', navigator.platform);

  var stateName = $state.current.name;

  $rootScope.currentPage = stateName.length > 1 ? stateName[1] : 'splash';

  $rootScope.$on('$stateChangeSuccess', function (e, newState, oldState) {
    var stateName = newState.name;
    $rootScope.currentPage = stateName.length > 1 ? stateName[1] : 'splash';
  });

  // b.className += ((!!('ontouchstart' in window) || !!('onmsgesturechange' in window))?' touch':'');

  // var stateName = $state.current.name.split('.');
  // $rootScope.currentPage = stateName.length > 1 ?
  //   stateName[1] :
  //   'splash';

  // var stateName = $state.current.name;
  // $rootScope.currentPage = stateName.length > 1 ? stateName[1] : 'splash';

  // $rootScope.$on('$stateChangeSuccess', function (e, newState, oldState) {
  //   var stateName = newState.name;
  //   $rootScope.currentPage = stateName.length > 1 ? stateName[1] : 'splash';
  // });

  // $rootScope.$on('$stateChangeSuccess', function(e, newState, oldState) {
  //   var stateName = newState.name.split('.');
  //   $rootScope.currentPage = stateName.length > 1 ?
  //     stateName[1] :
  //     'splash';
  // });
}


// WEBPACK FOOTER //
// ./components/layout.js